<template>
  <b-skeleton-wrapper :loading="HEADER_LOADING">
    <template #loading>
      <div>
        <div
          v-for="(item, index) in [1, 2]"
          :key="`item-${index}`"
          class="position-relative"
        >
          <b-row v-if="!item.deleted" class="whats-new__card">
            <b-col cols="12" class="whats-new__top-row">
              <b-skeleton width="10%"></b-skeleton>
              <b-skeleton width="10%"></b-skeleton>
            </b-col>
            <b-col
              v-for="(secondItem, secondIndex) in [1, 2, 3, 4]"
              :key="`second-item-${secondIndex}`"
              cols="12"
              class="padding-0"
            >
              <b-row class="margin-0">
                <b-col cols="12" class="whats-new__type-box">
                  <b-skeleton
                    type="avatar"
                    width="10px"
                    height="10px"
                    class="margin-left-8"
                  ></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                </b-col>
                <b-col
                  v-for="(thirdItem, thirdIndex) in [1, 2]"
                  :key="`third-item-${thirdIndex}`"
                  cols="12"
                  class="whats-new__description"
                >
                  <div class="padding-left-8 width-percent-100">
                    <b-skeleton width="100%"></b-skeleton>
                  </div>
                  <div class="flex-between color-complementary-200">
                    <b-skeleton
                      width="16px"
                      height="16px"
                      class="margin-left-4"
                    ></b-skeleton>
                    <b-skeleton width="16px" height="16px"></b-skeleton>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  inject: ["HEADER_LOADING"],
};
</script>
